import API from './api';

export default {

    getOrganization: (organizationId, supportsDefaults = true) => API({
        url: `organizations/${organizationId}?supportsDefaults=${supportsDefaults}`,
        method: 'GET',
    }),
    
    patchOrganization: (organization) => API({
        url: `organizations/${organization.id}`,
        method: 'PATCH',
        json: organization,
    }),

    generateLogoUploadUrl: (organizationId) => API({
        url: `organizations/${organizationId}/upload`,
        method: 'PUT',
    }),

    confirmLogoUpload: (organizationId, logoUrl, uploadKey) => API({
        url: `organizations/${organizationId}/logo`,
        method: 'PATCH',
        json: {
            logo_url: logoUrl,
            upload_key: uploadKey
        },
    }),

    createOrganization: (name, timezone) => API({
        url: 'organizations',
        method: 'POST',
        json: { name, timezone },
    }),

};
